import script from "./BannerSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&setup=true&lang=js"

import "./BannerSwiper.vue?vue&type=style&index=0&id=99f686cc&lang=scss"

const __exports__ = script;

export default __exports__